module.exports = __webpack_public_path__ + "img/NewVanIcon.7ef06996.svg";